// --- stringHtmlTags

import isString from "./isString.js"

export default function stripHtmlTags ( str ) {
    return isString( str )
        ? str.replace( /<(?:.|\n)*?>/gm, "" )
        : str
}